import * as QueryKeys from "data";

import { useIdentity } from "contexts/identity-context";

import { useQuery } from "@tanstack/react-query";
import {
  fetchCustomDatasets,
  fetchCustomDefinitions,
} from "data/queries-common";
import { useEffect, useState } from "react";
import { resolveIdentityId } from "utils/identity";
import { customColumns, customersToRows } from "./columns-rows";

import { ReactQueryErrorWrapper } from "components/shared/react-query-error-wrapper";
import CustomServerPaginatedTable from "components/shared/server-paginated-table";
import * as localStorageKeys from "data/local-storage-keys";
import { CustomDatasetFilterType, CustomDatasetList } from "data/models";
import usePaginatedTableQuery from "shared-hooks/use-paginated-table-query";
import FilterComponent from "../share-component/filter-component";
import { updateQueryAndFilters } from "../utils";
import { CustomDatasetFilters } from "./filters";

export const CustomDownloadPage = () => {
  const [identityState] = useIdentity();

  const identityId = resolveIdentityId(identityState);

  const savedSearch = localStorage.getItem(
    localStorageKeys.searchCustomDatasets,
  );

  let initialQueryFilterState: CustomDatasetFilterType = {
    name: [],
    query: "",
    product: [],
    release: "",
    latestRelease: false,
    customerName: [],
    notPublished: false,
  };

  const [queryFilterState, setQueryFilterState] =
    useState<CustomDatasetFilterType>(initialQueryFilterState);

  const [loadingFilters, setLoadingFilters] = useState<boolean>(false);

  const { paginationModel, handleChangePaginationModel, searchQuery } =
    usePaginatedTableQuery<CustomDatasetList>(
      (limit: number, offset: number) => {
        return fetchCustomDatasets(queryFilterState, limit, offset);
      },
      QueryKeys.customDatasetsSearchQuery,
      identityId,
      queryFilterState,
    );

  const definitions = useQuery({
    queryKey: [QueryKeys.customDatasetDefinitions],
    queryFn: () => fetchCustomDefinitions(),
  });

  useEffect(() => {
    updateQueryAndFilters({
      savedSearch: savedSearch,
      setQueryFilterState,
      setLoadingFilters,
      initialQueryFilterState,
      definitions: definitions,
    });
  }, []);

  const customColumns_ = customColumns();

  const isLoading = searchQuery.isPending;
  const rawsData = searchQuery.data ? customersToRows(searchQuery.data) : [];

  return (
    <>
      <div className="flex flex-col w-full gap-4 relative">
        <ReactQueryErrorWrapper
          queries={[searchQuery, definitions]}
          mutations={[]}
        />

        <FilterComponent
          queryFilterState={queryFilterState}
          setQueryFilterState={setQueryFilterState}
          initialQueryFilterState={initialQueryFilterState}
          renderFilter={CustomDatasetFilters}
          definitions={definitions}
          localStorageKey={localStorageKeys.searchCustomDatasets}
        />

        <CustomServerPaginatedTable
          rowCount={searchQuery.data?.links?.numberMatched ?? -1}
          paginationModel={paginationModel}
          setPaginationModel={handleChangePaginationModel}
          rows={rawsData}
          cols={customColumns_}
          isLoading={isLoading}
          overlayText={
            "We couldn't find any datasets that match your filter criteria."
          }
          disableColumnMenu
          disableColumnSelector
        />
      </div>
    </>
  );
};
